/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetSearchAutocompleteResponseAllOf,
    GetSearchAutocompleteResponseAllOfFromJSON,
    GetSearchAutocompleteResponseAllOfFromJSONTyped,
    GetSearchAutocompleteResponseAllOfToJSON,
} from './GetSearchAutocompleteResponseAllOf';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';
import {
    SearchAutcompleteSuggestion,
    SearchAutcompleteSuggestionFromJSON,
    SearchAutcompleteSuggestionFromJSONTyped,
    SearchAutcompleteSuggestionToJSON,
} from './SearchAutcompleteSuggestion';

/**
 * 
 * @export
 * @interface GetSearchAutocompleteResponse
 */
export interface GetSearchAutocompleteResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetSearchAutocompleteResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetSearchAutocompleteResponse
     */
    message: string;
    /**
     * 
     * @type {Array<SearchAutcompleteSuggestion>}
     * @memberof GetSearchAutocompleteResponse
     */
    data: Array<SearchAutcompleteSuggestion>;
}

export function GetSearchAutocompleteResponseFromJSON(json: any): GetSearchAutocompleteResponse {
    return GetSearchAutocompleteResponseFromJSONTyped(json, false);
}

export function GetSearchAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSearchAutocompleteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(SearchAutcompleteSuggestionFromJSON)),
    };
}

export function GetSearchAutocompleteResponseToJSON(value?: GetSearchAutocompleteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(SearchAutcompleteSuggestionToJSON)),
    };
}

